











import { Component, Vue } from "vue-property-decorator";
import { Getter, State } from "vuex-class";
import { Contract } from "@foxone/api/src/models/defi";

@Component
class EmptyContractAction extends Vue {
  @Getter("defi/contracts/getContracts") contracts!: Contract[];

  @State(state => state.defi.contracts.loading) loading!: boolean;

  get empty() {
    return !this.loading && this.contracts.length === 0;
  }

  handleBuy() {
    this.$helper.toFusionPath(this, "defi", { name: "index" });
  }
}
export default EmptyContractAction;
